var exports = {
  "k": "x127c5a35--322a87--container",
  "D": "x127c5a35--322a87--container--redesign",
};

module.exports = exports;
